export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
              每日更新 · 稳定流畅
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              宅男视频<span className="text-primary-500"> · </span>流畅高清不缓冲观影平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-700 mb-2 font-medium">
              聚合久久视频、小蓝视频、豆花视频，免费影视全集每日更新
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              宅男视频专注打造极速流畅的在线观影体验，深度接入久久视频、小蓝视频、豆花视频等稳定片源平台，
              覆盖电影、电视剧、综艺、动漫等全品类内容，每日同步更新最新资源。
              无广告干扰、不卡顿缓冲，让每一次观看都顺畅到底，久用依旧丝滑如初。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-refresh-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-700">每日更新资源</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-slideshow-line text-primary-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-700">多平台聚合片源</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-speed-up-line text-secondary-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-700">极速流畅不卡顿</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#index')}
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                开始观看
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#about')}
                className="px-8 py-3 border-2 border-secondary-300 hover:border-secondary-500 text-foreground-800 font-medium text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                了解详情
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20entertainment%20visual%20with%20warm%20red%20and%20gold%20gradient%20accents%2C%20flowing%20cinematic%20film%20strips%20and%20play%20button%20silhouettes%2C%20soft%20glowing%20light%20effects%2C%20dark%20theater%20atmosphere%20with%20warm%20ambient%20lighting%2C%20sleek%20modern%20composition%2C%20artistic%20minimal%20style%2C%20high%20detail&width=1200&height=900&seq=hero-visual-video-01&orientation=landscape"
                alt="宅男视频 - 流畅高清在线观影平台"
                className="w-full h-full object-cover"
                title="宅男视频流畅高清在线观看"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}